/**
 * @typedef {object} LinkContext
 * @property {string} [base]
 * @property {string} locale
 * @property {string} products
 * @property {string} exhibitors
 * @property {string} producers
 * @property {string} productLists
 * @property {string} favorites
 * @property {string} tastingList
 * @property {string} home
 */

/**
 * Returns the functions to create a link to a particular entity.
 * This is in CommonJS because it is also used from gatsby-node.
 * @param {LinkContext | undefined} context
 * @returns
 */
module.exports = function getLink(context) {
  return {
    /**
     * Returns the path to the countries list.
     * @returns
     */
    countries: () => path('regions'),

    /**
     * Generates a link to an country page.
     * @param {{ countryCode: string }} Bottlebooks country code
     * @returns
     */
    country: ({ countryCode }) => path('regions', countryCode),
    /**
     * Returns the path to the retions list.
     * @param {object} props
     * @param {string } props.countryCode Bottlebooks country code
     * @param {string } props.regionCode Bottlebooks region code
     * @returns
     */
    region: ({ countryCode, regionCode }) =>
      path('regions', countryCode, regionCode),

    /**
     * Generates a link to an country page.
     * @param {object} props
     * @param {string } props.countryCode Bottlebooks country code
     * @param {string } props.regionCode Bottlebooks region code
     * @param {string } props.subregionCode Bottlebooks subregion code
     * @returns
     */
    subregion: ({ countryCode, regionCode, subregionCode }) => {
      return path('regions', countryCode, regionCode, subregionCode);
    },
    /**
     * Generates a link for a page.
     * @param {object} page
     * @param {string} page.__typename
     * @param {object} [page.slug]
     * @param {string} [page.slug.current]
     * @param {string} [page.url]
     * @returns
     */
    page: (page) => {
      switch (page.__typename) {
        case 'BottlebooksPage':
        case 'SanityBottlebooksPage':
          // This value needs to be dynamically calculated based on context
          // return path(page.slug.current);
          return null;
        case 'SanityPage':
          return `/${page.slug.current}`;
        case 'Page':
          return `/cms-preview/pages/${page.id}`;
        case 'SanityExternalPage':
        case 'ExternalPage':
          return page.url;
        default:
          return null;
      }
    },
  };
};

function path(...segments) {
  return `/${segments.filter(Boolean).join('/')}`.replace(/\/\/+/g, '/');
}
